export * from './gpdr-info-redirect-dialog.component';
